// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.seller-payment-header {
  display: flex;
  align-items: center;
  font-family: Montserrat;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h5, 23px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding: 0.9375rem 0;
}
.empty-payments-section {
  justify-content: center;
  text-align: center;
}
.divider {
  margin: 0;
}
.no-payments-card {
  width: 30vw;
  height: max-content;
}
.no-payments-card .ant-card-body {
  width: auto;
  height: auto;
}
.no-payment-image {
  width: 13.3125rem;
  height: 13.3125rem;
  flex-shrink: 0;
}
.no-payments-text {
  font-family: Roboto;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h5, 23px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 3.375rem;
}
.overview-label {
  font-family: Roboto;
  color: var(--Colors-Text-300, #5b5e5d);
  font-size: var(--Font-Font-Size-h6, 1.1875rem);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 1.125rem;
}
.payment-card {
  height: 100%;
  width: 100%;
  .ant-card-body {
    padding: 15px 0 15px 25px;
  }
}
.payments-content {
  font-family: Roboto;
  color: var(--Colors-Text-300, #5b5e5d);
  text-align: center;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-top: 0.6875rem;
}
.divider {
  height: 0 !important;
  margin-bottom: 2rem;
}
.payment-card-headers {
  font-family: Roboto;
  color: var(--Colors-Text-300, #5b5e5d);
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.button-icon {
  display: flex;
  justify-content: end;
}
.pay-icon {
  display: flex;
  width: 2.5rem;
  height: 2.5rem;
  padding: 11px 10px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  cursor: auto;
}
.pay-icon:hover,
.pay-icon:active {
  border-color: #d9d9d9 !important;
}
.payout-price {
  font-family: Roboto;
  color: #000;
  font-size: var(--Font-Font-Size-h2, 2.5rem);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 1.25rem;
  display: inline-block;
}
.transferText {
  font-size: 1.1875rem;
  padding-top: 2.25rem;
  font-weight: 500;
}

.duration {
  font-family: Roboto;
  color: var(--Colors-Text-200, #8e9190);
  font-size: var(--Font-Font-Size-small, 0.8125rem);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  justify-self: flex-end;
  display: flex;
  margin-right: 1.4rem;
  margin-top: 1.875rem;
}
.update-column {
  width: 91%;
}
.update-btn {
  border-radius: 5px;
  background: var(--Colors-Primary-500, #d2042d);
  display: flex;
  width: 100%;
  height: 40px;
  padding: 8px 14px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 2.25rem;
}
.recent-campaigns-section {
  margin-top: 2.125rem;
  margin-bottom: 1.125rem;
  display: flex;
  justify-content: space-between;
}
.campaigns-container {
  width: 90vw;
}
.payout-label {
  font-family: Roboto;
  color: var(--Colors-Text-300, #5b5e5d);
  font-size: var(--Font-Font-Size-h6, 1.1875rem);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.view-all {
  font-family: Roboto;
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  cursor: pointer;
}
.payments-table {
  padding-bottom: 3.75rem;
  padding-right: 1rem;
}
.all-payments-table {
  max-height: 69vh;
  overflow-y: auto;
}
.partial-payments-table {
  max-height: 40vh;
  overflow-y: auto;
}
.payments-table .ant-table-thead > tr > th {
  text-align: left !important;
}
.status-badge {
  font-family: Roboto;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 7px;
}
.status-badge .ant-badge-count {
  height: 36px;
  opacity: 0.8;
  padding: 8px 27px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.badge-radius .ant-badge-count {
  border-radius: 35px;
}
.campaign-navigation {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
@media (max-width: 1024px) {
  .payout-price {
    font-size: 1.5rem;
  }
  .payment-method {
    width: 41vw !important;
  }
}
@media (max-width: 768px) {
  .no-payments-card {
    width: 80vw;
  }
  .payment-card {
    width: 100%;
    .ant-card-body {
      padding: 10px;
    }
  }
  .mobile-card {
    width: 90vw;
    margin-left: 0;
    text-align: left;
  }
  .payout-price {
    font-size: 1.4375rem;
    margin-right: 0.5rem;
  }

  .payment-card-headers {
    font-size: 0.75rem;
  }
  .update-btn {
    width: 84vw;
  }
  .campaign-labels {
    font-family: Roboto;
    color: var(--Colors-Text-300, #5b5e5d);
    font-size: var(--Font-Font-Size-small, 0.8125rem);
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .campaign-values {
    font-family: Roboto;
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-p, 1rem);
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .mobile-campaign-cards {
    margin-bottom: 1.125rem;
  }
  .mobile-campaign-cards .ant-card-body {
    padding-right: 0;
  }
  .status-section {
    display: flex;
    justify-content: end;
  }
  .status-badge {
    margin-top: -1rem;
  }
  .status-badge .ant-badge-count {
    height: 36px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    opacity: 0.8;
    padding: 8px 27px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .campaigns-container {
    width: auto;
  }
}

@media (max-width: 450px) {
  .status-badge .ant-badge-count {
    padding: 8px 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/SellerFlow/payments/Payments.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;AACd;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX;MACE,aAAa;IACf;EACF;EACA;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,sCAAsC;IACtC,iDAAiD;IACjD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,sCAAsC;IACtC,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".seller-payment-header {\n  display: flex;\n  align-items: center;\n  font-family: Montserrat;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h5, 23px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  padding: 0.9375rem 0;\n}\n.empty-payments-section {\n  justify-content: center;\n  text-align: center;\n}\n.divider {\n  margin: 0;\n}\n.no-payments-card {\n  width: 30vw;\n  height: max-content;\n}\n.no-payments-card .ant-card-body {\n  width: auto;\n  height: auto;\n}\n.no-payment-image {\n  width: 13.3125rem;\n  height: 13.3125rem;\n  flex-shrink: 0;\n}\n.no-payments-text {\n  font-family: Roboto;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h5, 23px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin-top: 3.375rem;\n}\n.overview-label {\n  font-family: Roboto;\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-size: var(--Font-Font-Size-h6, 1.1875rem);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-bottom: 1.125rem;\n}\n.payment-card {\n  height: 100%;\n  width: 100%;\n  .ant-card-body {\n    padding: 15px 0 15px 25px;\n  }\n}\n.payments-content {\n  font-family: Roboto;\n  color: var(--Colors-Text-300, #5b5e5d);\n  text-align: center;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  margin-top: 0.6875rem;\n}\n.divider {\n  height: 0 !important;\n  margin-bottom: 2rem;\n}\n.payment-card-headers {\n  font-family: Roboto;\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.button-icon {\n  display: flex;\n  justify-content: end;\n}\n.pay-icon {\n  display: flex;\n  width: 2.5rem;\n  height: 2.5rem;\n  padding: 11px 10px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  cursor: auto;\n}\n.pay-icon:hover,\n.pay-icon:active {\n  border-color: #d9d9d9 !important;\n}\n.payout-price {\n  font-family: Roboto;\n  color: #000;\n  font-size: var(--Font-Font-Size-h2, 2.5rem);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-top: 1.25rem;\n  display: inline-block;\n}\n.transferText {\n  font-size: 1.1875rem;\n  padding-top: 2.25rem;\n  font-weight: 500;\n}\n\n.duration {\n  font-family: Roboto;\n  color: var(--Colors-Text-200, #8e9190);\n  font-size: var(--Font-Font-Size-small, 0.8125rem);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  justify-self: flex-end;\n  display: flex;\n  margin-right: 1.4rem;\n  margin-top: 1.875rem;\n}\n.update-column {\n  width: 91%;\n}\n.update-btn {\n  border-radius: 5px;\n  background: var(--Colors-Primary-500, #d2042d);\n  display: flex;\n  width: 100%;\n  height: 40px;\n  padding: 8px 14px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  color: #fff;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-top: 2.25rem;\n}\n.recent-campaigns-section {\n  margin-top: 2.125rem;\n  margin-bottom: 1.125rem;\n  display: flex;\n  justify-content: space-between;\n}\n.campaigns-container {\n  width: 90vw;\n}\n.payout-label {\n  font-family: Roboto;\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-size: var(--Font-Font-Size-h6, 1.1875rem);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.view-all {\n  font-family: Roboto;\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: auto;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n  cursor: pointer;\n}\n.payments-table {\n  padding-bottom: 3.75rem;\n  padding-right: 1rem;\n}\n.all-payments-table {\n  max-height: 69vh;\n  overflow-y: auto;\n}\n.partial-payments-table {\n  max-height: 40vh;\n  overflow-y: auto;\n}\n.payments-table .ant-table-thead > tr > th {\n  text-align: left !important;\n}\n.status-badge {\n  font-family: Roboto;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: 7px;\n}\n.status-badge .ant-badge-count {\n  height: 36px;\n  opacity: 0.8;\n  padding: 8px 27px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.badge-radius .ant-badge-count {\n  border-radius: 35px;\n}\n.campaign-navigation {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: auto;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n@media (max-width: 1024px) {\n  .payout-price {\n    font-size: 1.5rem;\n  }\n  .payment-method {\n    width: 41vw !important;\n  }\n}\n@media (max-width: 768px) {\n  .no-payments-card {\n    width: 80vw;\n  }\n  .payment-card {\n    width: 100%;\n    .ant-card-body {\n      padding: 10px;\n    }\n  }\n  .mobile-card {\n    width: 90vw;\n    margin-left: 0;\n    text-align: left;\n  }\n  .payout-price {\n    font-size: 1.4375rem;\n    margin-right: 0.5rem;\n  }\n\n  .payment-card-headers {\n    font-size: 0.75rem;\n  }\n  .update-btn {\n    width: 84vw;\n  }\n  .campaign-labels {\n    font-family: Roboto;\n    color: var(--Colors-Text-300, #5b5e5d);\n    font-size: var(--Font-Font-Size-small, 0.8125rem);\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n  .campaign-values {\n    font-family: Roboto;\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-p, 1rem);\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n  .mobile-campaign-cards {\n    margin-bottom: 1.125rem;\n  }\n  .mobile-campaign-cards .ant-card-body {\n    padding-right: 0;\n  }\n  .status-section {\n    display: flex;\n    justify-content: end;\n  }\n  .status-badge {\n    margin-top: -1rem;\n  }\n  .status-badge .ant-badge-count {\n    height: 36px;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n    opacity: 0.8;\n    padding: 8px 27px;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n  .campaigns-container {\n    width: auto;\n  }\n}\n\n@media (max-width: 450px) {\n  .status-badge .ant-badge-count {\n    padding: 8px 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
